export default function Footer() {
    return (
        <div
            style={{ position: 'fixed', bottom: '1%', left: '1%', color:'white' }}
        >{process.env.REACT_APP_VERSION}</div>
    )
};